module.exports = __webpack_public_path__ + "static/media/add-user.6d1710c2.svg";